/**
 * `card` query parameter: a first-party app (카리픽) that already recommended a card
 * opens the payment window with that card company or easy-pay selected.
 * Only the selection is prefilled; terms, installment, signature and the pay button stay with the payer.
 */
export const PRESELECT_CARDS = ["KBPAY", "SHINHAN", "HANA", "HYUNDAI", "WOORI", "SAMSUNG", "BC"] as const;

type PreselectCard = (typeof PRESELECT_CARDS)[number];
export type Preselection = { method: "CARD"; card: PreselectCard } | { method: "NAVER" | "KAKAO" };

export function preselectFromSearch(search: string): Preselection | null {
  const value = new URLSearchParams(search).get("card");
  if (!value) return null;
  if ((PRESELECT_CARDS as readonly string[]).indexOf(value) >= 0) return { method: "CARD", card: value as PreselectCard };
  if (value === "NAVER" || value === "KAKAO") return { method: value };
  return null;
}
